const moduleName = "ViewportAnimate";

export default function ViewportAnimate() {
  const $elements = document.querySelectorAll<HTMLElement>(
    "[module-viewport-animate]:not([data-module-enabled-viewport-animate])"
  );
  $elements.forEach(($element: HTMLElement) => {
    handleEl($element);
  });
}

function toggleClassOnScrollToEnd(element) {
  let lastScrollTop = 0;

  window.addEventListener(
    "scroll",
    function () {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const elementRect = element.getBoundingClientRect();
      const offset = window.innerHeight + 300;
      const isAtBottom = elementRect.bottom <= offset;

      if (scrollTop > lastScrollTop) {
        // If we're scrolling down and we're at the bottom of the element
        if (isAtBottom) {
          element.classList.add("animation-up");
        } else {
          element.classList.remove("animation-up");
        }
      }

      // At the end of the function, update lastScrollTop
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    },
    false
  );
}

function toggleClassOnScrollToTop(element) {
  let lastScrollTop = 0;

  window.addEventListener(
    "scroll",
    function () {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const elementRect = element.getBoundingClientRect();
      const isAtTop = elementRect.top >= -300;

      if (scrollTop < lastScrollTop) {
        // If we're scrolling up and we're at the top of the element
        if (isAtTop) {
          element.classList.add("animation-up");
        } else {
          element.classList.remove("animation-up");
        }
      }

      // At the end of the function, update lastScrollTop
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    },
    false
  );
}

const handleEl = ($element: HTMLElement) => {
  $element.dataset[`moduleEnabled${moduleName}`] = "";
  toggleClassOnScrollToEnd($element); // When scrolling down
  toggleClassOnScrollToTop($element); // When scrolling up
};
